import * as React from 'react';

import { useAuth } from '../Auth';

import { SiteRoutesContext } from './SiteRoutesContext';
import { Routes } from './Routes';
import { isSecureRoute } from './isSecureRoute';
export type SiteRoutesProviderProps = {
  currentPath?: string;
  children: React.ReactNode;
};
export const SiteRoutesProvider = ({
  children,
  currentPath,
}: SiteRoutesProviderProps) => {
  const { logout, isAuthenticated, isLoading: isAuthLoading } = useAuth();

  React.useEffect(() => {
    if (!!isAuthLoading) {
      return;
    }
    if (!isAuthenticated && currentPath && isSecureRoute(currentPath)) {
      logout({ reasonCode: 'SESSION_EXPIRED' });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated, isAuthLoading, currentPath]); // purposefully not including logout

  return (
    <SiteRoutesContext.Provider value={{ routes: Routes, currentPath }}>
      {children}
    </SiteRoutesContext.Provider>
  );
};
